import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import color from "../../../Constants/colors";

interface Props {
  open: boolean;
  title: string;
  text: string;
  confirmLabel: string;
  pending: boolean;
  /** Shows a text field, e.g. for a reason, and passes its value on. */
  inputLabel?: string;
  inputRequired?: boolean;
  danger?: boolean;
  onConfirm: (input: string) => void;
  onClose: () => void;
}

const AmbassadorConfirmDialog: React.FC<Props> = ({
  open,
  title,
  text,
  confirmLabel,
  pending,
  inputLabel,
  inputRequired,
  danger,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation("ambassador");
  const [input, setInput] = useState("");
  const missingInput = Boolean(inputLabel && inputRequired && !input.trim());

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionProps={{ onExited: () => setInput("") }}
    >
      <DialogTitle sx={{ color: color.gray900, fontWeight: 700 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{text}</Typography>
        {inputLabel && (
          <TextField
            label={inputLabel}
            value={input}
            onChange={(event) => setInput(event.target.value)}
            required={inputRequired}
            multiline
            minRows={3}
            fullWidth
            sx={{ mt: 2 }}
            inputProps={{ maxLength: 5000 }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="secondary">
          {t("common.cancel")}
        </Button>
        <Button
          variant="contained"
          color={danger ? "error" : "primary"}
          disabled={pending || missingInput}
          onClick={() => onConfirm(input.trim())}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AmbassadorConfirmDialog;
